import React from 'react';

const CreateATripForWomen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-pink-200 via-purple-200 to-indigo-300 flex flex-col items-center justify-center">
      <h1 className="text-5xl font-extrabold text-gray-800 mb-8">إنشاء رحلة للنساء</h1>
      <div className="w-full md:w-2/3 lg:w-1/2 p-8 bg-white rounded-lg shadow-xl">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">صممي رحلة فريدة للنساء</h2>
        <p className="text-gray-600 mb-4">
          رحلاتنا المخصصة للنساء مصممة لتقديم تجارب لا تُنسى في بيئات آمنة وداعمة. سواء كنتِ تبحثين عن الانغماس الثقافي أو المغامرة، يمكننا تصميم الرحلة المثالية لكِ.
        </p>
        <button className="inline-block bg-purple-500 text-white py-2 px-4 rounded hover:bg-purple-600 transition">
          ابدئي بتصميم رحلتك
        </button>
      </div>
    </div>
  );
};

export default CreateATripForWomen;
